import { Its2Constants } from '@apps/its2/its2.constants';

import { StatsTicketingApi, StatsUrgencyApi } from '../../api/models';

export class StatsUrgency
{
    urgencyId: number;
    urgencyTradKey: string;
    count: number;
    percent: number;

    public static mapperFromApi = (source: StatsUrgencyApi): StatsUrgency =>
    {
        return {
            urgencyId: source.urgencyId,
            urgencyTradKey: Its2Constants.getUrgencyTradKey(source.urgencyId),
            count: source.count,
            percent: source.percent
        } as StatsUrgency;
    };
}

export class StatsTicketing
{
    incidents: StatsUrgency[];
    requests: StatsUrgency[];

    public static mapperFromApi = (source: StatsTicketingApi): StatsTicketing =>
    {
        const target = new StatsTicketing();

        target.incidents = source.incidents.map(StatsUrgency.mapperFromApi);
        target.requests = source.requests.map(StatsUrgency.mapperFromApi);

        return target;
    };
}
